<template>
    <div class="w-full flex xxs:flex-col lg:flex-row justify-between xxs:items-center lg:items-start lg:mb-4">
        <div class="flex items-center xxs:flex-col lg:flex-row">
            <div v-if="currentPagePDF" class="flex items-center">
                <CoreButton size="small" @click="previousPage">
                    Prev
                </CoreButton>
                <span class="text-default-1 text-body-6 px-4">page {{ `${currentPagePDF} / ${totalPagesPDF}` }}</span>
                <CoreButton size="small" @click="nextPage">
                    Next
                </CoreButton>
            </div>
            <label class="mb-2 ml-4" :class="!showAllPages && 'mt-5'">
                <input
                    type="checkbox"
                    :checked="showAllPages"
                    @change="$emit('update:showAllPages', $event.target.checked)"
                >
                <span class="text-body-6 text-default-1 ml-2">Show all pages</span>
            </label>
        </div>
        <div class="flex items-center xxs:mt-3 xxs:mb-3 lg:mt-0 lg:mb-0">
            <CoreButton size="small" @click="downsizePDF">
                -
            </CoreButton>
            <span class="text-default-1 text-body-6 px-4">{{ scalePDF }}%</span>
            <CoreButton size="small" @click="upsizePDF">
                +
            </CoreButton>
        </div>
    </div>
</template>

<script setup>
import CoreButton from "@/components/core/Button.vue";

const props = defineProps({
    currentPagePDF: {
        type: Number
    },
    totalPagesPDF: {
        type: Number
    },
    showAllPages: {
        type: Boolean
    },
    scalePDF: {
        type: Number
    },
});

const emit = defineEmits(['update:currentPagePDF', 'update:showAllPages', 'update:scalePDF', 'previousPage', 'nextPage']);

function downsizePDF() {
    const scale =  props.scalePDF > 25 ? props.scalePDF - 25 : props.scalePDF

    emit('update:scalePDF', scale);
}

function upsizePDF() {
    const scale =  props.scalePDF < 200 ? props.scalePDF + 25 : props.scalePDF

    emit('update:scalePDF', scale);
}

function previousPage() {
    const page = props.currentPagePDF > 1 ? props.currentPagePDF - 1 : props.currentPagePDF

    emit('update:currentPagePDF', page);
}

function nextPage() {
    const page = props.currentPagePDF < props.totalPagesPDF ? props.currentPagePDF + 1 : props.currentPagePDF

    emit('update:currentPagePDF', page);
}
</script>